import axios from 'axios'
import {AzSearchUrlBuilder} from '@azinformatica/loki'

class ReavaliacaoApiClient {

    async buscarReavaliacaoPorPatrimonio(dados) {
        return axios.get(`api/patrimonios/${dados.idPatrimonio}/reavaliacoes`)
    }

    async cadastrar(dados) {
        return axios.post('api/reavaliacoes', dados)
    }

    async buscarReavaliacaoPorId(reavaliacaoId) {
        return axios.get(`api/reavaliacoes/${reavaliacaoId}`)
    }

    async editarReavaliacao(dados) {
        return axios.put(`api/reavaliacoes/${dados.id}`, dados)
    }

    async buscarReavaliacoes(filtros, paginacao) {
        paginacao.descending = !paginacao.sortDesc[0]

        const url = AzSearchUrlBuilder.build(
            'api/reavaliacoes',
            filtros,
            paginacao
        )

        return axios.get(url)
    }

}

export default new ReavaliacaoApiClient()
